<template>
    <div class="modal fade" id="modal_subscription_stats" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestSubscription" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                         {{ i18n.t('views.clients.turnover.by_day.title') }}

                    </h5>
                    <button @click="closeModal('modal_subscription_stats', 'view')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-md-12 mb-4">
                            <strong>
                                {{ i18n.t('symbole.month') }} :
                            </strong> {{ i18n.t('date.month.' +
                                (defaultSearchBy?.month?.toLowerCase() ||
                                    '')) }}
                        </div>
                        <div class="col-md-6 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>{{ i18n.t('views.clients.turnover.table') }}</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class=" col-md-12">
                                            <div v-if="subscriptionsSalesList?.length"
                                                class="tab-pane fade in active show" id="members"
                                                style="overflow-x: auto;">
                                                <table class="datatables table table-striped table-bordered  ">
                                                    <thead class="thead-dark">
                                                        <tr>

                                                            <th> {{ i18n.t('symbole.day') }}</th>
                                                            <th> {{ i18n.t('symbole.year') }}</th>
                                                            <th> {{ i18n.t('tables.turnover.total') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(regulation, index) in subscriptionsSalesList"
                                                            value="member.id" v-bind:key="index">
                                                            <td>
                                                                {{ regulation?.day }}
                                                            </td>

                                                            <td>
                                                                {{ regulation?.year }}
                                                            </td>
                                                            <td>
                                                                {{ regulation?.total_amount?.toFixed(2) }} {{
                                                                    i18n.t('symbole.currency.mad') }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div>
                                                    <div class="d-flex align-items-center  mb-2 mt-2">
                                                        <p class="mb-0 dot-font-size">{{
                                                            i18n.t('tables.turnover.total_amount')
                                                        }}
                                                        </p>
                                                        <h4>{{ totalSales?.toFixed(2) }} {{
                                                            i18n.t('symbole.currency.mad') }}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <not-found :text="i18n.t('message.data_not_found.title')"
                                                    icon="warning" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3> {{ i18n.t('views.clients.turnover.chart') }}</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">

                                            <div v-if="subscriptionsSalesList?.length > 0">
                                                <doughnut-chart :chartData="chartData" />
                                            </div>
                                            <div v-else>
                                                <not-found :text="i18n.t('message.data_not_found.title')"
                                                    icon="warning" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>





                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, toRefs, watch } from "vue";
/*plugins*/

import i18n from "@/i18n/index"
/*composables & states */
import { useSubscription } from "@/composables/member/useSubscription";
import { subscriptions_amount_sales_by_day, clubUUID } from '@/shared/state';
import { usePermission } from "@/composables/auth/usePermission";
import { SubscriptionSalesQueryParams } from '@/interfaces/stats';
import { useGlobal } from "@/composables/global/useGlobal";
import { useModal } from '@/composables/modal/useModal';

const APP_URL = process.env.VUE_APP_URL;
export default defineComponent({
    components: {},
    name: "revenu-byday",
    props: {
        defaultSearchBy: {
            type: Object,
            default: null,
        },
        isModalOpen: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const chartLabels = ref<string[]>([]);
        const chartDatasets = ref<string[]>([]);
        const { defaultSearchBy, isModalOpen } = toRefs(props);
        const { closeModal } = useModal();
        const searchBy = ref<SubscriptionSalesQueryParams>({
            id: defaultSearchBy.value.id ?? null,
            end_date: defaultSearchBy.value.end_date ?? null,
            start_date: defaultSearchBy.value.start_date ?? null,
            pack_id: defaultSearchBy.value.pack_id ?? null,
            subscription_id: defaultSearchBy.value.subscription_id ?? null,
            is_renewal: null,
            reference_type: defaultSearchBy.value.reference_type ?? null,
            reference_id: null,

            clubUUID: clubUUID.value,
            memberUUID: defaultSearchBy.value.memberUUID ?? null,
            memberMatricule: defaultSearchBy.value.memberMatricule ?? null,
            isActive: defaultSearchBy.value.isActive ?? null,
            month: defaultSearchBy.value.month ?? null,
            month_key: defaultSearchBy.value.month_key ?? null,
            year: defaultSearchBy.value.year ?? null,
            byDay: "true",
            type: "all",
            page: defaultSearchBy.value.page ?? null,
            limit: defaultSearchBy.value.limit ?? null
        });

        const { fetchGlobalRevenuByDay, isRequestSubscription } = useSubscription();
        const { hasPermission } = usePermission();

        const subscriptionsSalesList = computed(() => subscriptions_amount_sales_by_day.data);
        const totalSales = computed(() => subscriptions_amount_sales_by_day.total);
        const chartData = computed(() => {

            subscriptionsSalesList?.value?.forEach((e: any) => {
                if (e) {
                    chartLabels.value.push(e.day)
                    chartDatasets.value.push(e.total_amount)
                }

            })
            const data = {
                labels: chartLabels.value,
                datasets: [
                    {
                        data: chartDatasets.value,
                        backgroundColor: ['#77CEFF', '#0079AF', '#123E6B', '#97B0C4', '#A5C8ED'],
                    }
                ],
            }
            return data
        });

        const fetchGlobalRevenuByDayData = () => {
            chartLabels.value = []
            chartDatasets.value = []
            searchBy.value.month = defaultSearchBy.value.month_key ?? null
            searchBy.value.year = defaultSearchBy.value.year ?? null
            searchBy.value.memberMatricule = defaultSearchBy.value.memberMatricule ?? null
            searchBy.value.reference_type = defaultSearchBy.value.reference_type ?? null
            fetchGlobalRevenuByDay(searchBy.value);
        };

        watch(() => defaultSearchBy.value, (newValue) => {
            console.log("isModalOpen")
            console.log(isModalOpen)
            if (newValue)
                fetchGlobalRevenuByDayData()
        }, { deep: true, immediate: true });

        return {
            subscriptionsSalesList,
            totalSales,
            fetchGlobalRevenuByDayData,
            i18n,
            chartLabels,
            chartDatasets,
            chartData,
            APP_URL,
            clubUUID,
            hasPermission,
            isRequestSubscription,
            closeModal,
            searchBy
        };
    },
});
</script>
